import { TCarouselSwiper } from 'widgets/global/CarouselSwiper';

/**
 * @description PersonalizationImagesCarousel implementation
 * @param CarouselSwiper Base widget for extending
 * @returns Personalization images carousel class
 */
function PersonalizationImagesCarouselClassCreator(CarouselSwiper: TCarouselSwiper) {
    class PersonalizationImagesCarousel extends CarouselSwiper {
        /**
         * @description Init carousel controls
         * @param options - swiper options
         */
        initControls(options): void {
            super.initControls(options);

            this.has('scrollbar', scrollbarEl => {
                const scrollbar = scrollbarEl.get();

                if (scrollbar) {
                    options.scrollbar = {
                        el: scrollbar,
                        draggable: true,
                        hide: false
                    };
                }
            });
        }
    }

    return PersonalizationImagesCarousel;
}

export default PersonalizationImagesCarouselClassCreator;
